import { locale, localeFr } from 'generated-locale';

export var Options = {
  featureIndexOverlayOption: false,
  announceMovement: false,
  announceScale: { metric: true, imperial: false },
  defaultExtCoor: 'pcrs',
  defaultLocCoor: 'gcrs',
  locale,
  localeFr
};
